export default "__VITE_ASSET__8cb1112c__"